// src/components/SocialLinksForm.js
import React, { useState, useEffect } from "react";
import axios from "axios";

const SocialLinksForm = ({ id }) => {
  const [socialLinks, setSocialLinks] = useState({
    facebookLink: "",
    twitterLink: "",
    instagramLink: "",
    linkedinLink: "",
    youtubeLink: "",
  });

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    // Fetch existing social link data if an ID is provided
    fetch(`${process.env.REACT_APP_BASE_API}/sociallinks`)
      .then((res) => res.json())
      .then((data) => {
        setSocialLinks(data[0]);
        console.log("data:", data);
        setLoading(false);
      })
      .catch((err) => {
        setError(err.message);
        setLoading(false);
      });
  }, [id]);

 
  const handleChange = (e) => {
    const { name, value } = e.target;
    setSocialLinks((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);

    const request = socialLinks._id
      ? axios.patch(
          `${process.env.REACT_APP_BASE_API}/sociallinks/${socialLinks?._id}`,
          socialLinks
        )
      : axios.post(
          `${process.env.REACT_APP_BASE_API}/sociallinks`,
          socialLinks
        );

    request
      .then((response) => {
        console.log("Success:", response.data);
        setLoading(false);
      })
      .catch((err) => {
        setError(err.message);
        setLoading(false);
      });
  };

  if (loading) {
    return <p>Loading...</p>;
  }

  if (error) {
    return <p>Error: {error}</p>;
  }

  return (
    <form onSubmit={handleSubmit} className="space-y-4">
      <div className="flex flex-col">
        <label className="text-sm font-medium text-gray-700">
          Facebook Link:
        </label>
        <input
          type="text"
          name="facebookLink"
          value={socialLinks.facebookLink}
          onChange={handleChange}
          className="mt-1 border rounded-md p-2 text-sm"
        />
      </div>
      <div className="flex flex-col">
        <label className="text-sm font-medium text-gray-700">
          Twitter Link:
        </label>
        <input
          type="text"
          name="twitterLink"
          value={socialLinks.twitterLink}
          onChange={handleChange}
          className="mt-1 border rounded-md p-2 text-sm"
        />
      </div>
      <div className="flex flex-col">
        <label className="text-sm font-medium text-gray-700">
          Instagram Link:
        </label>
        <input
          type="text"
          name="instagramLink"
          value={socialLinks.instagramLink}
          onChange={handleChange}
          className="mt-1 border rounded-md p-2 text-sm"
        />
      </div>
      <div className="flex flex-col">
        <label className="text-sm font-medium text-gray-700">
          LinkedIn Link:
        </label>
        <input
          type="text"
          name="linkedinLink"
          value={socialLinks.linkedinLink}
          onChange={handleChange}
          className="mt-1 border rounded-md p-2 text-sm"
        />
      </div>
      <div className="flex flex-col">
        <label className="text-sm font-medium text-gray-700">
          YouTube Link:
        </label>
        <input
          type="text"
          name="youtubeLink"
          value={socialLinks.youtubeLink}
          onChange={handleChange}
          className="mt-1 border rounded-md p-2 text-sm"
        />
      </div>
      <div className="flex justify-end">
        
      <button className=" bg-[#2792A8] text-xs rounded py-3 px-10 text-white font-semibold tracking-wider">
           Submit 
        </button>
      </div>
    </form>
  );
};

export default SocialLinksForm;
